/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Event types emitted over the WebSocket connection.
 * Must match the backend WssEventTypeEnum.
 */
export enum WssEventTypeEnum {
  /**
   * Emitted when successfully connected to the WebSocket server
   */
  CONNECTED = "connected",

  /**
   * Emitted when an error occurs
   */
  ERROR = "error",

  /**
   * Emitted when a partner-scoped event is received from the backend
   */
  PARTNER_EVENT = "partnerEvent"
}
